/*
 * Driver Login Screen
 *
 * Simple username/password login for garbage truck drivers.
 * Driver accounts are created by admins in the Drivers tab of the admin panel.
 */

import React, { useState } from 'react';
import axios from 'axios';
import { API } from '../../utils/config';

const DriverLogin = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username.trim() || !password) {
      setError('Please enter your username and password');
      return;
    }

    setLoading(true);
    setError('');
    try {
      const response = await axios.post(`${API}/driver/auth/login`, {
        username: username.trim(),
        password
      });
      onLogin(response.data.driver, response.data.access_token);
    } catch (err) {
      setError(err.response?.data?.detail || 'Login failed. Please check your credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-green-700 to-green-900 flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-6">
          <div className="text-6xl mb-3">🚛</div>
          <h1 className="text-2xl font-bold text-white">Driver Login</h1>
          <p className="text-green-100 text-sm mt-1">Clean City Belmopan</p>
        </div>

        <form onSubmit={handleSubmit} className="bg-white rounded-xl shadow-lg p-6 space-y-4">
          {error && (
            <div className="bg-red-50 border border-red-200 text-red-700 px-3 py-2 rounded text-sm">
              {error}
            </div>
          )}

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Username</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 text-base"
              placeholder="Your username"
              autoCapitalize="none"
              autoComplete="username"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 text-base"
              placeholder="Your password"
              autoComplete="current-password"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full py-3 bg-green-600 text-white font-semibold rounded-lg hover:bg-green-700 disabled:opacity-50 text-base"
          >
            {loading ? 'Logging in...' : 'Log In'}
          </button>

          <p className="text-xs text-gray-500 text-center pt-2">
            No account? Ask your administrator to create one for you.
          </p>
        </form>
      </div>
    </div>
  );
};

export default DriverLogin;
